import { useRef } from 'react';

export function useSubmitOnce() {
  const submittingRef = useRef(false);

  return (action: (onSettled: () => void) => void) => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    action(() => {
      submittingRef.current = false;
    });
  };
}
